var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlumbing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.5 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "plumbing"
  }, "Plumbing Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "plumbing"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 11.9h-1.1V0H33.9v11.9h-1.1v8.9h-8.2v.7H0v11.9h20.8c-1.7 2.6-3.3 5.7-3.3 8.4 0 3.4 2.6 6.1 5.8 6.1s5.8-2.7 5.8-6.1c0-3.3-2.3-4.7-3.4-7.3h12c.8 0 8.5-.7 8.9-10.5.1-4.7-.1-12.1-.1-12.1zM35.3 1.5h8.6v10.4h-8.6V1.5zM1.5 32v-8.9h23.1v4.3l-3.1-2.8-1.9 2.7-3-2.2-1.9 2.9 1.2.8 1.1-1.6 3 2.2 1.8-2.6 2.7 2.4c-.7.6-1.6 1.6-2.6 2.8H1.5zm26 9.9c0 2.6-1.9 4.7-4.3 4.7S19 44.4 19 41.9c0-3.1 2.6-7.3 4.7-9.8 0 2.7 1.2 4.4 2.2 5.9.9 1.2 1.6 2.3 1.6 3.9zM45 24c-.1 3.6-1.4 6.2-3.6 7.7-1.9 1.3-3.8 1.3-3.8 1.3H26V22.3h8.2v-8.9H45c.1 2.4.2 7.2 0 10.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.351 14.987l1.152-.96 1.857 2.228-1.152.96zM20.7 12.7h1.5v2.9h-1.5zM25.544 16.788l1.698-2.35 1.216.877-1.698 2.351zM22.6 42.9c-.5-.6-.4-1.8-.3-2.2.1-.4-.2-.8-.6-.9-.4-.1-.8.2-.9.6-.1.2-.5 2.3.7 3.5.5.5 1.2.8 2.1.8.3 0 .5 0 .8-.1.4-.1.7-.5.6-.9-.1-.4-.5-.7-.9-.6-.7.2-1.2.1-1.5-.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumbing);
export default __webpack_public_path__ + "static/media/plumbing.e465cacc67ca59f656db5e79de374278.svg";
export { ForwardRef as ReactComponent };